import React from 'react';
import { FormattedNumber } from 'react-intl';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../CMSEventTournament.scss';

export interface Payouts {
  position: string;
  prize: number;
}

export interface PayoutsData {
  payouts: Payouts[];
}

const PayoutsTable: React.FC<PayoutsData> = ({ payouts }) => (
  <div className={styles.tableContainer}>
    <table className={styles.eventsTable}>
      <thead>
        <tr>
          <th>Position</th>
          <th>Prize</th>
        </tr>
      </thead>
      <tbody>
        {payouts.map((item, index) => (
          <tr key={index}>
            <td>{item.position}</td>
            <td>
              <FormattedNumber style="decimal" value={item.prize} />
            </td>
          </tr>
        ))}
        {!payouts.length && (
          <tr>
            <td className={styles.textCenter} colSpan={2}>
              No Data
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default PayoutsTable;
